import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { App as AntdApp } from 'antd';
import i18n from '@/i18n';
import AntdLocaleProvider from './components/AntdLocaleProvider';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter>
    <I18nextProvider i18n={i18n}>
      <AntdLocaleProvider>
        <AntdApp>
          <App />
        </AntdApp>
      </AntdLocaleProvider>
    </I18nextProvider>
  </BrowserRouter>
);
